import { useWindowWidth } from 'hooks'

export const useMobileVersion = () => {
  const windowWidth = useWindowWidth()

  const isMobile = windowWidth < 768

  return isMobile
}
